import React from 'react';
import Button from './Button';
import { KeyCode, PdfPreviewOption } from '../util/Constants';

import './MultipageControls.css';

type Props = {
  current: number,
  total: number,
  onChange: Function
};

type State = {
  value: number,
  focus: boolean
};

class MultipageControls extends React.Component<Props, State> {
  state = {
    value: this.props.current,
    focus: false
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.current !== nextProps.current) {
      this.setState({ value: nextProps.current });
    }
  }

  onFocus = (e) => {
    if (e.target.setSelectionRange) {
      const len = e.target.value.length;
      e.target.setSelectionRange(0, len);
    }

    // this.setState({ focus: true });
  };

  onBlur = () => {
    // this.setState({ focus: false });
  };

  onKeyDown = (e) => {
    if (e.keyCode !== KeyCode.ENTER) {
      return;
    }

    const parsedVal = parseInt(this.state.value, 10);
    if (isNaN(parsedVal)) {
      return;
    }

    if (parsedVal < 1 || parsedVal > this.props.total) {
      return;
    }

    this.props.onChange(parsedVal);
  };

  onTextChange = (e) => {
    const { value } = e.target;
    if (isNaN(value) || value > this.props.total) {
      return;
    }
    this.setState({ value });
  };

  render() {
    const { current, total, onChange } = this.props;

    return (
      <div name="MultipageControls">
        <Button
          className="prev"
          disabled={current === 1}
          icon="images/prev.svg"
          onClick={() => onChange(current - 1)}
        />
        <div className="textbox">
          <input
            ref={(node) => (this._input = node)}
            value={this.state.value}
            onChange={this.onTextChange}
            onKeyDown={this.onKeyDown}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
          />
          <span className="divider" />
          <div className="total flex-row align-center justify-center" onClick={() => onChange(total)}>
            <span>{total}</span>
          </div>
        </div>
        <Button
          className="next"
          disabled={current === total}
          icon="images/next.svg"
          onClick={() => onChange(current + 1)}
        />
      </div>
    );
  }
}

export default MultipageControls;
